import React, { useState, useEffect, useRef } from 'react';
import add_driver from "../../../../../assets/images/add_driver.png";
import trash from "../../../../../assets/images/trash.png";
import remove_driver from "../../../../../assets/images/remove_driver.png";
import { Container, Row, Col, Modal, Button, Tab, Tabs, Dropdown, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import bin from '../../../../../assets/images/bin.png';
import info from '../../../../../assets/images/info.png';
import green_check from '../../../../../assets/images/green_check.png';
import { SLOTPLANNINGAVAILABLESLOT, GETOWNERCODE } from '../../../../../Utils/conts.js';
// import "../../../../../assets/css/stepper.css";
import { faPlus, faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popup from 'reactjs-popup';
import { jqxCookieCall } from '../../../../../Components/common/CommonFunctions.js';
const TripEditModal = ({ rowData, setRowData, onSuccess, mode = null, setMode }) => {
    const isMounted = useRef(false);
    const [disLoading, setDisLoading] = useState(false);
    const [showModalRequestSlot, setShowModalRequestSlot] = useState(false);
    const [getDestination, setGetDestination] = useState([]);
    const [driver2, setDriver2] = useState(false);
    const [orderDetailsModal, setOrderDetailsModal] = useState(false);
    const [gridSelectData, setGridSelectData] = useState([]);
    const [isLoadingod, setIsLoadingOd] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tripEditData, setTripEditData] = useState([]);
    const [selectedHandler, setSelectedHandler] = useState(null);
    const gridRefs = useRef({});
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [initialFormData, setInitialFormData] = useState({});
    // const [initialState, setInitialState] = useState(true);
    const initialState = useRef(true);
    const [handlerOptionsByLocation, setHandlerOptionsByLocation] = useState({});
    const dragSeqRef = useRef({ locationIndex: null, seqIndex: null });
    const dragOverSeqRef = useRef({ locationIndex: null, seqIndex: null });
    const [draggingSeq, setDraggingSeq] = useState(null);
    const [selectedSeq, setSelectedSeq] = useState(null);
    const cargoConditionOptions = [
        { label: 'Loose', value: 'loose' },
        { label: 'Intact', value: 'intact' },
    ];
    const defaultSequence = (seqIndex = 0) => ({
        id: Date.now() + Math.random(),
        flight_prefix: "",
        flight_no: "",
        truck_date: "",
        intact_loose: "",
        loading_sequence: seqIndex + 1,
    });
    const defaultLocation = () => ({
        staion_name: "AMS",
        staion_id: "AMS",
        handler_name: "",
        handler_id: "",
        trip_status: "",
        sequences: [defaultSequence(0)],
    });
    const [todFormData, setTodFormData] = useState([defaultLocation()]);
    const addLocation = () => {
        // setTodFormData(prev => [...prev, defaultLocation()]);
        setTodFormData(prev => {
            const updated = [...prev, defaultLocation()];
            syncSbFromTod(updated);
            return updated;
        });
    };
    const deleteLocation = (locationIndex) => {
        // setTodFormData(prev => prev.filter((_, i) => i !== locationIndex));
        setTodFormData(prev => {
            const updated = prev.filter((_, i) => i !== locationIndex);
            syncSbFromTod(updated);
            return updated;
        });
    };
    const addSequence = (locationIndex) => {
        // setTodFormData(prev => {
        //     const updated = [...prev];
        //     const sequences = [...updated[locationIndex].sequences];
        //     sequences.push(defaultSequence(sequences.length));
        //     updated[locationIndex] = {
        //         ...updated[locationIndex],
        //         sequences,
        //     };
        //     return updated;
        // });
        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];
            sequences.push(defaultSequence(sequences.length));

            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences,
            };

            syncSbFromTod(updated); // ✅ ADD
            return updated;
        });
    };
    const removeSequence = (locationIndex, seqIndex) => {
        // setTodFormData(prev => {
        //     const updated = [...prev];
        //     updated[locationIndex] = {
        //         ...updated[locationIndex],
        //         sequences: updated[locationIndex].sequences.filter((_, i) => i !== seqIndex),
        //     };
        //     return updated;
        // });
        setTodFormData(prev => {
            const updated = [...prev];
            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences: updated[locationIndex].sequences.filter((_, i) => i !== seqIndex),
            };

            syncSbFromTod(updated); // ✅ ADD
            return updated;
        });
    };
    const updateLocationField = (locationIndex, name, value) => {
        // setTodFormData(prev => {
        //     const updated = [...prev];
        //     updated[locationIndex] = { ...updated[locationIndex], [name]: value };
        //     return updated;
        // });
        setTodFormData(prev => {
            const updated = [...prev];
            updated[locationIndex] = { ...updated[locationIndex], [name]: value };
            syncSbFromTod(updated);
            return updated;
        });
    };
    const updateSequenceField = (locationIndex, seqIndex, name, value) => {
        // setTodFormData(prev => {
        //     const updated = [...prev];
        //     const sequences = [...updated[locationIndex].sequences];
        //     sequences[seqIndex] = { ...sequences[seqIndex], [name]: value };

        //     updated[locationIndex] = {
        //         ...updated[locationIndex],
        //         sequences,
        //     };

        //     return updated;
        // });
        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];

            sequences[seqIndex] = {
                ...sequences[seqIndex],
                [name]: value
            };

            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences,
            };

            syncSbFromTod(updated); // ✅ ADD
            return updated;
        });
    };
    const changeSequenceOrder = (locationIndex, fromIndex, toIndex) => {
        if (fromIndex === toIndex) return;

        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];

            const [moved] = sequences.splice(fromIndex, 1);
            sequences.splice(toIndex, 0, moved);

            const reordered = sequences.map((seq, i) => ({
                ...seq,
                loading_sequence: i + 1
            }));

            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences: reordered
            };

            syncSbFromTod(updated);
            return updated;
        });
    };
    const resetForm = () => {
        setTodFormData([defaultLocation()]);
        setTdFormData({
            driver1_first_name: "",
            driver1_last_name: "",
            license_plate: "",
            side_loading: "",
            trip_status: "",
            orderDetails: [
                {
                    order_no: '',
                    truck_no: '',
                    truck_date: ''
                }
            ]
        });
        setSbFormData({
            loading: [],
            unloading: []
        })
    };
    const [tdFormData, setTdFormData] = useState({
        driver1_first_name: "",
        driver1_last_name: "",
        license_plate: "",
        side_loading: "",
        trip_status: "",
        orderDetails: [
            {
                order_no: '',
                truck_no: '',
                truck_date: ''
            }
        ]
    });
    const [sbFormData, setSbFormData] = useState({
        loading: [],
        unloading: []
    });
    const [activeStep, setActiveStep] = useState();
    const steps = [
        { id: 1, title: "Trip Details", sub_title: "Enter vehicle and driver information for this trip." },
        { id: 2, title: "Truck Order Details", sub_title: "Enter the handler locations and assign the truck orders involved in this trip." },
        { id: 3, title: "Slot Booking", sub_title: "Indicate planning time to book a timeslot at the handler." }
    ];
    useEffect(() => {
        if (isMounted.current) return;
        fetchDestination();
        isMounted.current = true;
    }, []);
    useEffect(() => {
        console.log("todFormData:", todFormData);
    }, [todFormData]);
    useEffect(() => {
        console.log("initialFormData:", initialFormData);
    }, [initialFormData]);
    useEffect(() => {
        if (mode == 'create') {
            setShowModalRequestSlot(true);
            resetForm();
            return;
        }
        const tripId = rowData?.trip_id || rowData?.id;
        if (tripId) {
            getTripData(tripId);
        }
        const typeOf = rowData?.typeOf;
        if (typeOf) {
            setActiveStep(3);
        } else {
            setActiveStep(1);
        }
        fetchOwnerCode();
    }, [rowData, mode]);
    useEffect(() => {
        if (showModalRequestSlot == true) return;
        setActiveStep(1);
        setGridSelectData([]);
        setTripEditData([]);
        setTdFormData({
            driver1_first_name: "",
            driver1_last_name: "",
            license_plate: "",
            side_loading: "",
            trip_status: "",
            orderDetails: [
                {
                    order_no: '',
                    truck_no: '',
                    truck_date: '',
                    cargo_condition: ''
                }
            ]
        });
        setSbFormData({
            loading: [],
            unloading: []
        });
    }, [showModalRequestSlot]);
    useEffect(() => {
        if (sbFormData.loading.warehouse_id && sbFormData.loading.date) {
            availableSlot(sbFormData.loading.date, sbFormData.loading.warehouse_id, 'loading');
        }
    }, [sbFormData.loading.date]);
    useEffect(() => {
        if (sbFormData.unloading.warehouse_id && sbFormData.unloading.date) {
            availableSlot(sbFormData.unloading.date, sbFormData.unloading.warehouse_id, 'unloading');
        }
    }, [sbFormData.unloading.date]);
    const handleStepClick = (stepId) => {
        if (stepId == 2) {
            if (!validateTdStep([
                'driver1_first_name',
                'driver1_last_name',
                // 'side_loading',
                'trip_status',
                'trailer_license_plate',
                'truck_license_plate'
            ])) {
                toast.error('Please fill all mandatory fields before proceeding.')
                return;
            }
        }
        if (activeStep === 2 && stepId != 1) {
            if (!validateTodStep()) {
                return; // toast already shown
            }
        }
        setActiveStep(stepId);
    };
    const handleChange = (form, event) => {
        const { name, value } = event.target;
        if (form === "td") {
            setTdFormData(prev => ({ ...prev, [name]: value }));
        }
        if (form === "sb") {
            setSbFormData(prev => ({ ...prev, [name]: value }));
        }
        if (form === "tod") {
            setTodFormData(prev => ({ ...prev, [name]: value }));
        }
    };
    const refreshGrid = () => {
        const grid = window.$(gridRefs.current);
        grid.jqxGrid('updatebounddata');
        grid.jqxGrid('refresh');
    };
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post('trip-management/get-station-with-warehouses', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData.map(item => ({
                        value: item.code,
                        label: item.code,
                        port_Id: item.port_Id,
                        station_users: item.station_users
                    }));
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const getHandlersByStation = (stationCode, handlerOrgId) => {
        const station = getDestination.find(s => s.label === stationCode);
        if (!station || !station.station_users) return [];
        return station.station_users
            .filter(user => user.org_id === handlerOrgId)
            .flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    station_user_id: user.id
                }))
            );
    };
    const StationLoop = ({ type, data, setSbFormData }) => {
        useEffect(() => {
            data.forEach((item, index) => {
                const hasValidInputs =
                    item.date &&
                    item.warehouse_id &&
                    item.handler_org_id;
                const slots = item.availableSlots;
                const slotsNotLoaded =
                    !item.availableSlots ||
                    (
                        item.availableSlots.past?.length === 0 &&
                        !item.availableSlots.present &&
                        item.availableSlots.future?.length === 0 &&
                        !item.availableSlots.message
                    );

                if (hasValidInputs && slotsNotLoaded) {
                    if (mode == "create") {
                        availableSlot(
                            item.date,
                            item.warehouse_id,
                            type,
                            index,
                            setSbFormData
                        );
                    }
                }
                if (
                    slots?.present?.door_id &&
                    !item.selected_slot_key
                ) {
                    setSbFormData(prev => {
                        const updated = [...prev[type]];
                        updated[index] = {
                            ...updated[index],
                            selected_slot_type: 'present',
                            selected_slot_key: `${slots.present.door_id}_${slots.present.start_time}`,
                            slot: slots.present,
                            sequences: item.sequences
                        };

                        return { ...prev, [type]: updated };
                    });
                } else if (
                    item.selected_slot_key &&
                    item.selected_slot_type === 'present' &&
                    !slots?.present?.door_id
                ) {
                    setSbFormData(prev => {
                        const updated = [...prev[type]];
                        updated[index] = {
                            ...updated[index],
                            selected_slot_type: null,
                            selected_slot_key: null,
                            slot: null,
                            sequences: item.sequences
                        };
                        return { ...prev, [type]: updated };
                    });
                }
            });
        }, [data, type, setSbFormData]);
        return (
            <>
                {data.map((item, index) => {
                    const slots = item.availableSlots || {
                        past: [],
                        present: null,
                        future: [],
                        message: ""
                    };
                    const handlerOptions = getHandlersByStation(item.station, item.handler_org_id);
                    return (
                        <div className={`${type}Loop Loop`} key={`${type}-${index}`}>
                            <div className='truck_no'>
                                <h4>Truck No : {item.truckNos} </h4>
                                {/* <p></p> */}
                            </div>
                            <div className="rounded charter_top charter_from">
                                <Form.Group as={Row} className="mb-1">
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            <>
                                                <label className="form-label">
                                                    Station Code <span>*</span>
                                                </label>
                                                <Select classNamePrefix="rs"
                                                    options={getDestination}
                                                    value={getDestination.find(o => o.label === item.station)}
                                                    onChange={(selected) => {
                                                        setSbFormData(prev => {
                                                            const updated = [...prev[type]];
                                                            updated[index] = {
                                                                ...updated[index],
                                                                station: selected.label,
                                                                station_id: selected.port_Id,
                                                                handler_org_id: null,
                                                                handler_name: "",
                                                                warehouse_id: null,
                                                                availableSlots: {
                                                                    past: [],
                                                                    present: null,
                                                                    future: [],
                                                                    message: ""
                                                                }
                                                            };
                                                            return { ...prev, [type]: updated };
                                                        });
                                                    }}
                                                    isDisabled="true"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <label className="form-label">Station Code</label>
                                                <div className="form-control bg-light">
                                                    {item.station || "—"}
                                                </div>
                                            </>
                                        )}

                                    </Col>
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            handlerOptions.length > 0 ? (
                                                <>
                                                    <label className="form-label">
                                                        Handler Name <span>*</span>
                                                    </label>
                                                    <Select
                                                        classNamePrefix="rs"
                                                        options={handlerOptions}
                                                        value={handlerOptions.find(
                                                            o => o.value === item.warehouse_id
                                                        )}
                                                        onChange={(selected) => {
                                                            setSbFormData(prev => {
                                                                const updated = [...prev[type]];
                                                                updated[index] = {
                                                                    ...updated[index],
                                                                    warehouse_id: selected.warehouse_id,
                                                                    selected_slot_type: null,
                                                                    selected_slot_key: null,
                                                                    slot: null,
                                                                    availableSlots: {
                                                                        past: [],
                                                                        present: null,
                                                                        future: [],
                                                                        message: ""
                                                                    }
                                                                };
                                                                return { ...prev, [type]: updated };
                                                            });
                                                            if (item.date) {
                                                                availableSlot(
                                                                    item.date,
                                                                    selected.warehouse_id,
                                                                    type,
                                                                    index,
                                                                    setSbFormData
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <label className="form-label">Handler Name</label>
                                                    <div className="form-control bg-light">
                                                        {item.handler_name || "—"}
                                                        {/* <p className='text-danger'>Door planning not applied, arrival reference only.</p> */}
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                <label className="form-label">Handler Name</label>
                                                <div className="form-control bg-light">
                                                    {item.handler_name || "—"}
                                                    {/* <p className='text-danger'>Door planning not applied, arrival reference only.</p> */}
                                                </div>
                                            </>
                                        )}
                                    </Col>
                                </Form.Group>
                            </div>
                            <div className="rounded charter_top h-90 px-1 bookig_slot">
                                <div className="calendar-container">
                                    <Form.Group as={Row} className="mb-1">
                                        <Col sm="12">
                                            <label className='form-label'>Planned Date / Time</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                value={item.date || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setSbFormData(prev => {
                                                        const updated = [...prev[type]];
                                                        const warehouseId = updated[index].warehouse_id;
                                                        updated[index] = {
                                                            ...updated[index],
                                                            date: value,
                                                            selected_slot_type: null,
                                                            selected_slot_key: null,
                                                            slot: null,
                                                            availableSlots: {
                                                                past: [],
                                                                present: null,
                                                                future: [],
                                                                message: ""
                                                            }
                                                        };
                                                        return { ...prev, [type]: updated };
                                                    });
                                                    if (item.warehouse_id) {
                                                        availableSlot(
                                                            value,
                                                            item.warehouse_id,
                                                            type,
                                                            index,
                                                            setSbFormData
                                                        );
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Form.Group>
                                    {slots.message && (
                                        <p
                                            className={
                                                slots.code === 400
                                                    ? 'text-danger'
                                                    : slots.code === 405
                                                        ? 'text-inactive'
                                                        : ''
                                            }
                                        >
                                            {slots.message}
                                        </p>
                                    )}
                                    {item.handler_org_id ? (
                                        handlerOptions.length > 0 ? (
                                            <></>
                                        ) : (
                                            <>
                                                <p className='text-inactive'>Door planning not applied, arrival reference only.</p>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <p className='text-inactive'>Door planning not applied, arrival reference only.</p>
                                        </>
                                    )}
                                    <div className="timeslot previous">
                                        {item?.planned_date_time && (
                                            <>
                                                <div className="available time available_time_selected">
                                                    {/* <h4>Door No.: {item?.slots?.door_details.door_no}</h4> */}

                                                    <span>{item?.planned_date_time?.split(' ')[0]}</span>- {' '}
                                                    <span>{item?.request_booking_slot}</span>
                                                    {/* - {' '}
                                                            <span>{item?.slot?.end_time}</span> */}
                                                </div>
                                            </>
                                        )
                                        }
                                    </div>
                                    {!slots.present?.door_id &&
                                        (slots.past.length > 0 || slots.future.length > 0) && (
                                            <p className="text-danger">
                                                No timeslot available at the selected time. Please select an open option below.
                                            </p>
                                        )}

                                    {slots.present?.door_id && (
                                        <>
                                            <h4 className='avl_time' onClick={() =>
                                                handleSlotClick(
                                                    type,
                                                    index,
                                                    'present',
                                                    slots.present,
                                                    setSbFormData
                                                )
                                            }>
                                                <span>
                                                    <img src={green_check} alt='green_check' />
                                                </span>Timeslot Available {' '}
                                                <span className='ps-2'>
                                                    {formatTime(slots.present.start_time)} {" "} - {" "}
                                                    {formatTime(slots.present.end_time)}
                                                </span> { }
                                            </h4>
                                        </>
                                    )}
                                    {!slots.present?.door_id && (
                                        <>
                                            {slots.past.length > 0 && (
                                                <div className="avalable">
                                                    <h2>Earlier Timeslot</h2>
                                                    <div className="timeslot">
                                                        {slots.past.map((slot, i) => (
                                                            <div key={i} className={`available time ${isSelectedSlot(item, 'past', slot) ? 'available_tym' : ''}`} onClick={() =>
                                                                handleSlotClick(
                                                                    type,
                                                                    index,
                                                                    'past',
                                                                    slot,
                                                                    setSbFormData
                                                                )
                                                            }>
                                                                {/* <h4>Door No.: {slot.door_no}</h4> */}
                                                                {/* <p>{formatDate(slot.start_time)}</p> */}
                                                                <p>
                                                                    {slot.start_time}  - {slot.end_time}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {slots.future.length > 0 && (
                                                <div className="avalable">
                                                    <h2>Later Timeslot</h2>
                                                    <div className="timeslot">
                                                        {slots.future.map((slot, i) => (
                                                            <div key={i} className={`available time  ${isSelectedSlot(item, 'future', slot) ? 'available_tym' : ''}`} onClick={() =>
                                                                handleSlotClick(
                                                                    type,
                                                                    index,
                                                                    'future',
                                                                    slot,
                                                                    setSbFormData
                                                                )
                                                            }>
                                                                <p>
                                                                    {slot.start_time}  -  {slot.end_time}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };
    const goPrevious = () => {
        if (activeStep > 1) setActiveStep(activeStep - 1);
    };
    const handleSubmit = async () => {
        setDisLoading(true);
        const order_ids = (gridSelectData || []).map(o => o.id);
        const slot_booking = [
            ...(sbFormData.loading || []).map(item => {
                const d = new Date(item.date);
                const station_id = getDestination.find(station => station.label === item.station)?.port_Id || null;
                return {
                    shipping_type: "L",
                    station: item.station,
                    station_id: station_id,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    planned_date_time: item.date,
                    date: d.toISOString().split("T")[0],
                    time: d.toTimeString().slice(0, 8),
                    warehouse_id: item.warehouse_id,
                    id: item.id ?? null,
                    slot: item.slot || null,
                    sequences: item.sequences || null,

                };
            }),
            ...(sbFormData.unloading || []).map(item => {
                const d = new Date(item.date);
                const station_id = getDestination.find(station => station.label === item.station)?.port_Id || null;
                return {
                    shipping_type: "U",
                    station: item.station,
                    station_id: station_id,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    planned_date_time: item.date,
                    date: d.toISOString().split("T")[0],
                    time: d.toTimeString().slice(0, 8),
                    warehouse_id: item.warehouse_id,
                    id: item.id ?? null,
                    slot: item.slot || null,
                    sequences: item.sequences || null,

                };
            })
        ];
        const payload = {
            trip_details: {
                trip_status: tdFormData.trip_status,
                vehicle_type: "Truck",
                side_loading: tdFormData.side_loading,
                truck_license_plate: tdFormData.truck_license_plate,
                trailer_license_plate: tdFormData.trailer_license_plate ?? "",
                driver1_first_name: tdFormData.driver1_first_name,
                driver1_last_name: tdFormData.driver1_last_name,
                driver2_first_name: tdFormData.driver2_first_name ?? "",
                driver2_last_name: tdFormData.driver2_last_name ?? ""
            },
            order_ids,
            slot_booking,
            truck_order_details: todFormData,
            trip_id: tripEditData.trip_id ?? null
        };
        console.log("Submitting payload:", payload);
        try {
            const res = await withRFSToken.post('trip-management/save-trip', payload)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        setShowModalRequestSlot(false);
                        toast.success(res.data.response_msg);
                        setTimeout(() => {
                            onSuccess();
                        }, 200);
                        setDisLoading(false);
                    } else {
                        setDisLoading(false);
                        toast.error(res.data.response_msg);
                    }

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const goNext = () => {
        if (!validateTdStep([
            'driver1_first_name',
            'driver1_last_name',
            // 'side_loading',
            'trip_status',
            'trailer_license_plate',
            'truck_license_plate'
        ])) {
            toast.error('Please fill all mandatory fields before proceeding.')
            return;
        }
        if (activeStep === 2) {
            if (!validateTodStep()) {
                return; // toast already shown
            }
        }
        if (activeStep < steps.length) setActiveStep(activeStep + 1);
    };
    const loadGrid = () => {
        if (gridRefs.current) {
            // const token = 'Bearer ' + localStorage.Trucking;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                url: `${process.env.REACT_APP_RFS_URL}order-view-list`,
                root: 'Rows',
                cache: false,
                datafields: [
                    { name: 'id', type: 'number' },
                    { name: 'order_no', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'truck_date', type: 'string' }
                ],
                // beforeSend: (jqXHR) => {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                filter: function (allfilters) {
                    window.$(gridRefs.current).jqxGrid('clearselection');
                    window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    if (data && data.Rows) {
                        // data.Rows = data.Rows.map(row => ({
                        //     ...row,
                        //     order_no: row.order?.order_no || '',
                        //     truck_no: row.order?.truck_no || '',
                        //     truck_date: row.order?.truck_date || ''
                        // }));
                        source.totalrecords = data.TotalRows;
                    }
                }
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Order No', datafield: 'order_no', width: '33%' },
                { text: 'Truck No', datafield: 'truck_no', width: '33%' },
                {
                    text: 'Truck Date',
                    datafield: 'truck_date',
                    width: '33%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (!cellValue) return '';
                        const formattedDate = new Date(cellValue).toISOString().split('T')[0];
                        return `<div style="margin-top:8px;">${formattedDate}</div>`;
                    }
                }
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                pagesizeoptions: ['20', '100', '200', '500'],
                pageable: true,
                pageSize: 20,
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                selectionmode: 'checkbox',
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs.current).jqxGrid(gridOptions);
            window.$(gridRefs.current).on('rowselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);

                setGridSelectData(prev => {
                    // Prevent duplicate entry
                    if (prev.some(row => row.id === rowData.id)) {
                        return prev;
                    }
                    return [...prev, rowData];
                });
            });
            window.$(gridRefs.current).on('rowunselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);

                setGridSelectData(prev =>
                    prev.filter(row => row.id !== rowData.id)
                );
            });
            window.$(gridRefs.current).on('bindingcomplete', function () {
                syncGridSelection();
            });
        }
    };
    const uncheckGridRowById = (id) => {
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        const rowIndex = rows.findIndex(r => r.id === id);
        if (rowIndex !== -1) {
            window.$(gridRefs.current).jqxGrid('unselectrow', rowIndex);
        }
    };
    const syncGridSelection = () => {
        if (!gridRefs.current || !gridSelectData.length) return;
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        gridSelectData.forEach(selected => {
            const rowIndex = rows.findIndex(r => r.id === selected.id);
            if (rowIndex !== -1) {
                window.$(gridRefs.current).jqxGrid('selectrow', rowIndex);
            }
        });
    };
    const handleAddorder = async () => {
        try {
            const res = await withRFSToken.post("trip-management/get-order-shippings", { order_ids: gridSelectData.map(item => item.id) })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const loadingArr = [];
                    const unloadingArr = [];
                    const addTodData = [];

                    innerData?.forEach((item, index) => {
                        const truckNos = item.truck_nos.join(", ");;
                        const baseObj = {
                            station: item.station,
                            handler_org_id: item.handler_org_id,
                            slots: item.slots,
                            id: item.id,
                            handler_name: item.handler_name,
                            warehouse_id: null,
                            date: item.planned_date_time,
                            availableSlots: {
                                past: [],
                                present: null,
                                future: []
                            },
                            truckNos: truckNos
                        };

                        if (item.shipping_type === "L") {
                            loadingArr.push(baseObj);
                        }

                        if (item.shipping_type === "U") {
                            unloadingArr.push(baseObj);
                        }
                        const handlers = fetchHandler(item.station);
                        setHandlerOptionsByLocation(prev => ({
                            ...prev,
                            [index]: handlers
                        }));

                        const truckData = [];
                        item?.truck_data?.forEach((item, index) => {
                            const onlyDate = item?.truck_date?.split("T")[0];
                            truckData.push({
                                id: Date.now() + index,
                                flight_prefix: item.truck.code,
                                flight_no: item.truck.number,
                                truck_date: onlyDate,
                                intact_loose: "",
                                loading_sequence: index + 1
                            });
                        });

                        addTodData.push({
                            staion_name: item.station,
                            staion_id: item.station,
                            handler_name: item.handler_name || "",
                            handler_id: item.warehouse_id || "",
                            handler_org_id: item.handler_org_id,
                            slots: item.slots,
                            trip_status: item.shipping_type,
                            sequences: truckData
                        })
                    });

                    setSbFormData({
                        loading: loadingArr,
                        unloading: unloadingArr
                    });
                    setTodFormData(addTodData);
                    setOrderDetailsModal(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const validateTdStep = (fields) => {
        for (const field of fields) {
            if (!tdFormData[field] || tdFormData[field].toString().trim() === '') {
                return false;
            }
        }

        return true;
    };
    const availableSlot = async (date, warehouseId, type, index, setSbFormData) => {
        if (!date || !warehouseId) return;
        try {
            const [dateVal, timeVal] = date.split("T");
            const sequences = sbFormData[type][index].sequences || [];
            const intactLoose = getIntactLooseMeta(sequences);
            const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOT, {
                warehouse_id: warehouseId,
                date: dateVal,
                time: timeVal,
                cargo_type_id: intactLoose.code,
                trip_type_id: tdFormData.trip_status === 'Import' ? 4 : 5,
            });
            setSbFormData(prev => {
                const updated = [...prev[type]];
                if (res.data.response_code === 200) {
                    const {
                        recentBefore = [],
                        recentSlots = null,
                        upcomingAfter = []
                    } = res.data.response_data || {};
                    updated[index] = {
                        ...updated[index],
                        availableSlots: {
                            past: recentBefore,
                            present: recentSlots,
                            future: upcomingAfter,
                            message: ""
                        }
                    };
                } else {
                    updated[index] = {
                        ...updated[index],
                        availableSlots: {
                            past: [],
                            present: null,
                            future: [],
                            message: res.data.response_msg,
                            code: res.data.response_code
                        }
                    };
                }
                return { ...prev, [type]: updated };
            });

        } catch (err) {
            console.error("Available slot fetch failed", err);
        }
    };
    const getIntactLooseMeta = (sequences = []) => {
        if (!sequences.length) {
            return { label: null, code: null };
        }
        const allIntact = sequences.every(
            seq => seq.intact_loose === "Intact"
        );
        const label = allIntact ? "Intact" : "Loose";
        const code = label === "Loose" ? 1 : 2;

        return { label, code };
    };
    const handleSlotClick = (type, index, slotType, slot, setSbFormData) => {
        setSbFormData(prev => {
            const updated = [...prev[type]];
            updated[index] = {
                ...updated[index],
                selected_slot_type: slotType,
                selected_slot_key: `${slot.door_id}_${slot.start_time}`,
                slot: slot,
            };
            return {
                ...prev,
                [type]: updated
            };
        });
    };
    const formatTime = (datetime) => {
        return new Date(datetime).toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    };
    const isSelectedSlot = (item, slotType, slot) => {
        if (!item.selected_slot_key) return false;

        const slotKey = `${slot.door_id}_${slot.start_time}`;

        return (
            item.selected_slot_type === slotType &&
            item.selected_slot_key === slotKey
        );
    };
    const getTripData = async (id) => {
        try {
            const res = await withRFSToken.post('trip-details', { trip_id: id })//9637
                .then(function (res) {
                    initialState.current = true;
                    setTripEditData(res.data);
                    const data = res.data;
                    setGridSelectData(data.orders);
                    if (data.trip_details.driver2_first_name) {
                        setDriver2(true);
                    } else {
                        setDriver2(false);
                    }
                    setTdFormData({
                        driver1_first_name: data.trip_details.driver1_first_name ?? "",
                        driver1_last_name: data.trip_details.driver1_last_name ?? "",
                        driver2_first_name: data.trip_details.driver2_first_name ?? "",
                        driver2_last_name: data.trip_details.driver2_last_name ?? "",
                        truck_license_plate: data.trip_details.truck_license_plate ?? "",
                        trailer_license_plate: data.trip_details.trailer_license_plate ?? "",
                        side_loading: data.trip_details.side_loading ?? "",
                        trip_status: data.trip_details.trip_status ?? "",
                        orderDetails: (data.order_ids || []).map(orderId => ({
                            order_no: orderId,
                            truck_no: "",
                            truck_date: ""
                        }))
                    });
                    const loading = [];
                    const unloading = [];
                    (data.slot_booking || []).forEach(item => {
                        const truckNos = [...new Set(
                            item.order_shippings
                                ?.map(os => os.order?.truck_no)
                                .filter(Boolean)
                        )].join(", ");
                        const slotItem = {
                            station: item.station,
                            station_id: item.station_id,
                            handler_org_id: item.handler_org_id,
                            handler_name: item.handler_name,
                            warehouse_id: item.warehouse_id,
                            slots: item.slots[0],
                            id: item.id,
                            planned_date_time: item.planned_date_time,
                            request_booking_slot: item.request_booking_slot,
                            date: item.planned_date_time
                                ? item.planned_date_time.replace(" ", "T")
                                : null,
                            availableSlots: {
                                past: [],
                                present: null,
                                future: [],
                                message: ""
                            },
                            truckNos: truckNos
                        };
                        if (item.shipping_type === "L") {
                            loading.push(slotItem);
                        }
                        if (item.shipping_type === "U") {
                            unloading.push(slotItem);
                        }
                    });
                    setSbFormData({
                        loading,
                        unloading
                    });
                    syncGridSelection();
                    setShowModalRequestSlot(true);
                    const todData = (data.truck_order_details || []).map((loc) => ({
                        staion_name: loc.staion_name || "",
                        staion_id: loc.staion_id || "",
                        handler_name: loc.handler_name || "",
                        handler_id: loc.handler_id || "",
                        handler_org_id: loc.handler_org_id || "",
                        trip_status: loc.trip_status || "",
                        sequences: (loc.sequences || []).map((seq, index) => ({
                            id: seq.id ?? Date.now() + index,
                            flight_prefix: seq.flight_prefix || "",
                            flight_no: seq.flight_no || "",
                            truck_date: seq.truck_date || "",
                            intact_loose: seq.intact_loose || "",
                            loading_sequence: seq.loading_sequence ?? (index + 1)
                        }))
                    }));

                    setTodFormData(todData.length ? todData : [defaultLocation()]);
                    syncSbFromTod(todData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (activeStep !== 3) return;
        if (!tdFormData.trip_status) return;
        ['loading', 'unloading'].forEach(type => {
            (sbFormData[type] || []).forEach((item, index) => {
                if (item.date && item.warehouse_id) {
                    const changesBool = compareInitialWithCurrent(todFormData, initialFormData);

                    if (mode != "create") {
                        if (changesBool === 1) {
                            availableSlot(item.date, item.warehouse_id, type, index, setSbFormData);
                        } else {
                            setSbFormData(prev => {
                                const resetSection = (section = []) =>
                                    section.map(item => ({
                                        ...item,
                                        availableSlots: {
                                            past: [],
                                            present: null,
                                            future: [],
                                            message: ""
                                        },
                                        slot: null,
                                    }));

                                return {
                                    loading: resetSection(prev.loading),
                                    unloading: resetSection(prev.unloading)
                                };
                            });
                        }
                    }
                }
            });
        });
    }, [activeStep]);
    const compareInitialWithCurrent = () => {
        if (!initialFormData || !initialFormData.todFormData) return 1;
        const initialTod = initialFormData.todFormData;
        const normalize = (data) => {
            return data.map(item => ({
                staion_name: item.staion_name || "",
                staion_id: item.staion_id || "",
                handler_name: item.handler_name || "",
                handler_id: item.handler_id || null,
                handler_org_id: item.handler_org_id || null,
                trip_status: item.trip_status || "",
                sequences: (item.sequences || []).map(seq => ({
                    flight_prefix: seq.flight_prefix || "",
                    flight_no: seq.flight_no || "",
                    truck_date: seq.truck_date || "",
                    intact_loose: seq.intact_loose || "",
                    loading_sequence: seq.loading_sequence || null
                }))
            }));
        };
        const normalizedCurrent = normalize(todFormData);
        const normalizedInitial = normalize(initialTod);
        return JSON.stringify(normalizedCurrent) === JSON.stringify(normalizedInitial) ? 0 : 1;
    };
    const validateTodStep = () => {
        for (let locIndex = 0; locIndex < todFormData.length; locIndex++) {
            const loc = todFormData[locIndex];

            // Location-level validation
            if (!loc.staion_name) {
                toast.error(`Station Code is mandatory (Location ${locIndex + 1})`);
                return false;
            }

            if (!loc.handler_name) {
                toast.error(`Handler Name is mandatory (Location ${locIndex + 1})`);
                return false;
            }

            if (!loc.trip_status) {
                toast.error(`Please select Loading or Unloading (Location ${locIndex + 1})`);
                return false;
            }

            // Sequence-level validation
            for (let seqIndex = 0; seqIndex < (loc.sequences || []).length; seqIndex++) {
                const seq = loc.sequences[seqIndex];

                if (!seq.flight_prefix || !seq.flight_no) {
                    toast.error(
                        `Truck Number is mandatory (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`
                    );
                    return false;
                }

                if (!seq.truck_date) {
                    toast.error(
                        `Truck Date is mandatory (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`
                    );
                    return false;
                }

                if (!seq.intact_loose) {
                    toast.error(
                        `Please select Intact or Loose (Location ${locIndex + 1}, Sequence ${seqIndex + 1})`
                    );
                    return false;
                }
            }
        }

        return true;
    };
    const fetchHandler = (stationCode) => {
        try {
            const station = getDestination.find(s => s.value === stationCode);
            if (!station || !station.station_users) return [];

            return station.station_users.flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    handler_org_id: user.handler_org_id,
                    station_user_id: user.id
                }))
            );
        } catch (error) {
            console.error("Error fetching handler data:", error);
            return [];
        }
    };
    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        pref: item.AWB_prefix
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const reorderSequences = (locationIndex, fromIndex, toIndex) => {
        // if (fromIndex === toIndex) return;
        // setTodFormData(prev => {
        //     const updated = [...prev];
        //     const sequences = [...updated[locationIndex].sequences];
        //     const [movedItem] = sequences.splice(fromIndex, 1);
        //     sequences.splice(toIndex, 0, movedItem);
        //     const updatedSequences = sequences.map((seq, i) => ({
        //         ...seq,
        //         loading_sequence: i + 1
        //     }));
        //     updated[locationIndex] = {
        //         ...updated[locationIndex],
        //         sequences: updatedSequences
        //     };
        //     return updated;
        // });
        if (fromIndex === toIndex) return;

        setTodFormData(prev => {
            const updated = [...prev];
            const sequences = [...updated[locationIndex].sequences];
            const [movedItem] = sequences.splice(fromIndex, 1);
            sequences.splice(toIndex, 0, movedItem);

            const updatedSequences = sequences.map((seq, i) => ({
                ...seq,
                loading_sequence: i + 1
            }));

            updated[locationIndex] = {
                ...updated[locationIndex],
                sequences: updatedSequences
            };

            syncSbFromTod(updated); // ✅ ADD
            return updated;
        });
    };
    const syncSbFromTod = (todData) => {
        let allData;

        setSbFormData(prev => {
            const newLoading = [];
            const newUnloading = [];

            todData.forEach(loc => {
                if (!loc.trip_status) return;

                const sequences = (loc.sequences || []).map(seq => ({
                    flight_prefix: seq.flight_prefix,
                    flight_no: seq.flight_no,
                    truck_date: seq.truck_date,
                    intact_loose: seq.intact_loose,
                    loading_sequence: seq.loading_sequence
                }));

                const existing =
                    prev.loading.find(
                        l => l.station === loc.staion_name && l.handler_org_id === loc.handler_org_id
                    ) ||
                    prev.unloading.find(
                        u => u.station === loc.staion_name && u.handler_org_id === loc.handler_org_id
                    );

                const baseObj = {
                    id: existing?.id ?? null,
                    station: loc.staion_name,
                    station_id: loc.staion_id,
                    handler_org_id: loc.handler_org_id,
                    handler_name: loc.handler_name,
                    warehouse_id: loc.handler_id || null,
                    date: existing?.date ?? null,
                    planned_date_time: existing?.planned_date_time ?? null,
                    request_booking_slot: existing?.request_booking_slot ?? null,
                    slot: existing?.slot ?? null,
                    availableSlots: existing?.availableSlots ?? {
                        past: [],
                        present: null,
                        future: [],
                        message: ""
                    },
                    sequences,
                    truckNos: buildTruckNosFromSequences(sequences)
                };

                if (loc.trip_status === "L") newLoading.push(baseObj);
                if (loc.trip_status === "U") newUnloading.push(baseObj);
            });

            allData = {
                loading: newLoading,
                unloading: newUnloading
            };

            return allData;
        });

        // ✅ Set initialFormData OUTSIDE updater
        if (initialState.current && todData?.length > 0) {
            setInitialFormData({
                todFormData: todData,
                sbFormData: allData
            });
            initialState.current = false;
        }
    };
    // const syncSbFromTod = (todData) => {
    //     setSbFormData(prev => {
    //         const newLoading = [];
    //         const newUnloading = [];
    //         todData.forEach(loc => {
    //             if (!loc.trip_status) return;

    //             const sequences = (loc.sequences || []).map(seq => ({
    //                 flight_prefix: seq.flight_prefix,
    //                 flight_no: seq.flight_no,
    //                 truck_date: seq.truck_date,
    //                 intact_loose: seq.intact_loose,
    //                 loading_sequence: seq.loading_sequence
    //             }));
    //             const existing =
    //                 prev.loading.find(l => l.station === loc.staion_name && l.handler_org_id === loc.handler_org_id)
    //                 || prev.unloading.find(u => u.station === loc.staion_name && u.handler_org_id === loc.handler_org_id);

    //             const baseObj = {
    //                 id: existing?.id ?? null,
    //                 station: loc.staion_name,
    //                 station_id: loc.staion_id,
    //                 handler_org_id: loc.handler_org_id,
    //                 handler_name: loc.handler_name,
    //                 warehouse_id: loc.handler_id || null,
    //                 date: existing?.date ?? null,
    //                 planned_date_time: existing?.planned_date_time ?? null,
    //                 request_booking_slot: existing?.request_booking_slot ?? null,
    //                 slot: existing?.slots ?? null,
    //                 availableSlots: existing?.availableSlots ?? {
    //                     past: [],
    //                     present: null,
    //                     future: [],
    //                     message: ""
    //                 },
    //                 sequences,
    //                 truckNos: buildTruckNosFromSequences(sequences)
    //             };

    //             if (loc.trip_status === "L") newLoading.push(baseObj);
    //             if (loc.trip_status === "U") newUnloading.push(baseObj);
    //         });

    //         return {
    //             loading: newLoading,
    //             unloading: newUnloading
    //         };
    //     });        
    // };
    const buildTruckNosFromSequences = (sequences = []) => {
        return sequences
            .filter(seq => seq.flight_prefix && seq.flight_no)
            .map(seq => `${seq.flight_prefix}${seq.flight_no}`)
            .join(", ");
    };
    useEffect(() => {
        if (!getDestination.length) return;

        setHandlerOptionsByLocation(prev => {
            const updated = { ...prev };

            todFormData.forEach((location, index) => {
                if (
                    location.staion_name &&
                    !updated[index] // only load once
                ) {
                    const handlers = fetchHandler(location.staion_id);
                    updated[index] = handlers;
                }
            });

            return updated;
        });
    }, [getDestination, todFormData]);

    return (
        <>
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {console.log('showModalRequestSlot',showModalRequestSlot)}
            <Modal show={showModalRequestSlot} onHide={() => { setShowModalRequestSlot(false); resetForm(); setRowData(); setMode(); }} className='addfrom change_type truck_monitor_modal create_trip' centered size={'xl'} scrollable={false}>
                <Modal.Header closeButton className='position-relative'>
                    {/* {activeStep === 2 &&
                        <Button onClick={() => setOrderDetailsModal(true)} className='mb-0 addtodBtn'>Existing Order</Button>
                    } */}
                </Modal.Header>
                <Modal.Body>
                    <div className="stepper-wrapper">
                        <div className="stepper-left">
                            <h4 className="stepper-title">CREATE TRIP</h4>
                            <div className="stepper-menu">
                                {steps.map((step, index) => {
                                    const isActive = step.id === activeStep;
                                    const isCompleted = step.id < activeStep;
                                    return (
                                        <div key={step.id} className={`stepper-item ${isActive ? "active" : ""}`} onClick={() => handleStepClick(step.id)}>
                                            <div className={`step-number ${isCompleted ? "completed" : isActive ? "active-number" : ""}`}>
                                                {isCompleted ? "✓" : step.id}
                                            </div>
                                            <div className="step-text">{step.title}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="stepper-content position-relative new_onestep">
                            <h2>{steps.find((s) => s.id === activeStep)?.title}</h2>
                            <h6>{steps.find((s) => s.id === activeStep)?.sub_title}</h6>
                            {activeStep === 2 &&
                                <Button onClick={() => setOrderDetailsModal(true)} className='mb-0 addtodBtn'><span className='d-flex align-items-center'><FontAwesomeIcon icon={faPlus} className='ps-1' /> Add Existing Order</span>  </Button>
                            }
                            <div className="step-content-box">
                                {activeStep === 1 &&
                                    <div>
                                        <Row>
                                            <Col md={6}>

                                                <div className='driver_truck_details'>
                                                    <Form.Group className="mb-2">
                                                        <label className="form-label">Export / Import <span>*</span>
                                                            <span className='ps-3'>
                                                                {/* <Popup trigger={<span className=''><img src={info} alt="Info" />
                                                                </span>} on={['hover', 'focus']} position="center" className="info_popup popup_text">
                                                                    <div>
                                                                        <h6>Export / Import</h6>
                                                                        <p>Select whether the trip concerns an Export or Import RFS movement.</p>
                                                                        <p>**Export** means the cargo is delivered to the handler for a connecting flight at the arrival location. </p>
                                                                        <p>**Import** means the cargo is collected from the handler after flight arrival and transported further by road to its final destination.</p>
                                                                    </div>

                                                                </Popup> */}
                                                                <OverlayTrigger
                                                                    show={showTooltip}
                                                                    placement="right"
                                                                    overlay={
                                                                        <Tooltip id="export-import-tooltip"></Tooltip>
                                                                    }
                                                                >
                                                                    <span
                                                                        className="export_import_tooltip"
                                                                        style={{ display: "inline-block", cursor: "pointer" }}
                                                                        onMouseEnter={() => setShowTooltip(true)}
                                                                        onMouseLeave={() => setShowTooltip(false)}
                                                                    >
                                                                        <img src={info} alt="Info" />
                                                                    </span>
                                                                </OverlayTrigger>

                                                                {showTooltip &&
                                                                    <>
                                                                        <div className='tooltip_contents'>
                                                                            <p><b>Export / Import</b></p>
                                                                            <p>Select whether the trip concerns an Export or Import RFS movement.</p>
                                                                            <p><b>**Export** </b>means the cargo is delivered to the handler for a connecting flight at the arrival location.</p>
                                                                            <p><b>**Import**</b> means the cargo is collected from the handler after flight arrival and transported further by road to its final destination.</p>
                                                                        </div>

                                                                    </>
                                                                }
                                                            </span>
                                                        </label>

                                                        <div className='d-flex'>
                                                            <Form.Check
                                                                type="radio"
                                                                id="vehicle-truck"
                                                                label="Export"
                                                                name="trip_status"
                                                                value="Export"
                                                                checked={tdFormData.trip_status === "Export"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "trip_status", value: "Export" } })
                                                                }
                                                            />

                                                            <Form.Check
                                                                type="radio"
                                                                id="vehicle-van"
                                                                label="Import"
                                                                name="trip_status"
                                                                value="Import"
                                                                checked={tdFormData.trip_status === "Import"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "trip_status", value: "Import" } })
                                                                }
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <label className="form-label">Truck License Plate <span>*</span></label>
                                                        <Form.Control
                                                            type="text"
                                                            name="truck_license_plate"
                                                            value={tdFormData.truck_license_plate}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <label className="form-label">Trailer License Plate <span>*</span></label>
                                                        <Form.Control
                                                            type="text"
                                                            name="trailer_license_plate"
                                                            value={tdFormData.trailer_license_plate}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Driver 1 First Name <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="driver1_first_name"
                                                            value={tdFormData.driver1_first_name}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Driver 1 Last Name <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="driver1_last_name"
                                                            value={tdFormData.driver1_last_name}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    {/* <Button onClick={() => { setDriver2(true) }} className='w-50'>Add Driver 2</Button> */}
                                                    <Link to="#" className="w-100 d-inline-block text-end pe-2 add_driver"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setDriver2(prev => {
                                                                const next = !prev;
                                                                if (!next) {
                                                                    setTdFormData(prevData => ({
                                                                        ...prevData,
                                                                        driver2_first_name: '',
                                                                        driver2_last_name: ''
                                                                    }));
                                                                }
                                                                return next;
                                                            });
                                                        }}
                                                    >
                                                        {/* {driver2 ? 'Remove Driver 2' : 'Add Driver 2'} */}
                                                        <button>
                                                            {driver2 ? (
                                                                <>
                                                                    <img src={remove_driver} alt="Remove" className="pe-2" width={25} />
                                                                    Remove Driver 2
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={add_driver} alt="Add" className="pe-2" width={25} />
                                                                    Add Driver 2
                                                                </>
                                                            )}
                                                        </button>
                                                    </Link>
                                                    {driver2 &&
                                                        <>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label>Driver 2 First Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="driver2_first_name"
                                                                    value={tdFormData.driver2_first_name}
                                                                    onChange={(e) => handleChange("td", e)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label>Driver 2 Last Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="driver2_last_name"
                                                                    value={tdFormData.driver2_last_name}
                                                                    onChange={(e) => handleChange("td", e)}
                                                                />
                                                            </Form.Group>
                                                        </>
                                                    }
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                {/* <div className='oder_details driver_truck_details'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <h6>Order Details</h6>
                                                        <Button onClick={() => setOrderDetailsModal(true)}>Add</Button>
                                                    </div>
                                                    {gridSelectData.map((order, index) => (
                                                        <div className="order_details_list" key={order.id ?? index}>
                                                            <Row className={'w-100 justify-content-center'}>
                                                                <Col sm={5}>
                                                                    <div className="oder_no">
                                                                        <h6>Order No.</h6>
                                                                        <p>{order.order_no ?? '-'}</p>
                                                                    </div>
                                                                    <div className="truck_no">
                                                                        <h6>Truck No.</h6>
                                                                        <p>{order.truck_no ?? '-'}</p>
                                                                    </div>
                                                                </Col>
                                                                <Col sm={6}>
                                                                    <div className="truck_no">
                                                                        <h6>Truck Date</h6>
                                                                        <p>{order.truck_date
                                                                            ? new Date(order.truck_date).toISOString().split('T')[0]
                                                                            : ''
                                                                        }</p>
                                                                    </div>
                                                                    <Form.Group className="mb-2">
                                                                        <Form.Label>Intact/Loose</Form.Label>
                                                                        <Select
                                                                            classNamePrefix="rs"
                                                                            options={cargoConditionOptions}
                                                                            placeholder="Select"
                                                                            value={cargoConditionOptions.find(
                                                                                opt =>
                                                                                    tdFormData.orderDetails[index]?.cargo_condition === opt.value
                                                                            )}
                                                                            onChange={(selected) => {
                                                                                setTdFormData(prev => {
                                                                                    const updatedOrders = [...prev.orderDetails];
                                                                                    updatedOrders[index] = {
                                                                                        ...updatedOrders[index],
                                                                                        cargo_condition: selected.value
                                                                                    };

                                                                                    return {
                                                                                        ...prev,
                                                                                        orderDetails: updatedOrders
                                                                                    };
                                                                                });
                                                                            }}
                                                                            className='intact_loose_drpdwn'
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col sm={1}>
                                                                    <div className="dlt_icon"
                                                                        onClick={() =>
                                                                            setGridSelectData(prev =>
                                                                                prev.filter((_, i) => i !== index)
                                                                            )
                                                                        }
                                                                    >
                                                                        <img src={bin} alt="bin" />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    ))}
                                                </div> */}
                                            </Col>
                                        </Row>
                                    </div>
                                }
                                {activeStep === 2 &&
                                    <div>
                                        {todFormData.map((location, locationIndex) => (
                                            <div className="trip_card" key={locationIndex}>
                                                {/* TOP PART (Station + Handler + Loading/Unloading) */}
                                                <Row className="align-items-center mb-3">
                                                    <Col md={6}>
                                                        <Row>
                                                            <Col sm="5">
                                                                <label className="form-label">Station Code <span>*</span></label>
                                                                <Select
                                                                    options={getDestination}
                                                                    placeholder="Station"
                                                                    className="autoslct w-100"
                                                                    value={getDestination.find(opt => opt.value === location.staion_id) || null}
                                                                    onChange={(selected) => {
                                                                        updateLocationField(locationIndex, "staion_name", selected.label);
                                                                        updateLocationField(locationIndex, "staion_id", selected.value);

                                                                        // Reset handler if station changes
                                                                        updateLocationField(locationIndex, "handler_name", "");
                                                                        updateLocationField(locationIndex, "handler_id", "");

                                                                        const handlers = fetchHandler(selected.value);

                                                                        setHandlerOptionsByLocation(prev => ({
                                                                            ...prev,
                                                                            [locationIndex]: handlers
                                                                        }));
                                                                    }}
                                                                />

                                                            </Col>

                                                            <Col sm="7">
                                                                <label className="form-label">Handler Name <span>*</span></label>
                                                                {/* <Select
                                                                    options={handlerOptionsByLocation[locationIndex] || []}
                                                                    placeholder="Handler Name"
                                                                    className="autoslct me-0 w-100"
                                                                    value={
                                                                        (handlerOptionsByLocation[locationIndex] || []).find(
                                                                            option => option.value === location.handler_id
                                                                        ) || null
                                                                    }
                                                                    onChange={(selected) => {
                                                                        updateLocationField(locationIndex, "handler_name", selected.label);
                                                                        updateLocationField(locationIndex, "handler_id", selected.value);
                                                                    }}
                                                                /> */}
                                                                {location?.staion_name === "AMS" ? (
                                                                    <Select
                                                                        isDisabled={!location.staion_name}
                                                                        styles={{
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                backgroundColor: !location.staion_name ? "#e9ecef" : base.backgroundColor,
                                                                            }),
                                                                        }}
                                                                        options={handlerOptionsByLocation[locationIndex] || []}
                                                                        placeholder="Handler Name"
                                                                        className="autoslct me-0 w-100"
                                                                        value={
                                                                            (handlerOptionsByLocation[locationIndex] || []).find(
                                                                                option => option.value === location.handler_id
                                                                            ) || null
                                                                        }
                                                                        onChange={(selected) => {
                                                                            updateLocationField(locationIndex, "handler_name", selected.label);
                                                                            updateLocationField(locationIndex, "handler_id", selected.value);
                                                                            updateLocationField(locationIndex, "handler_org_id", selected.handler_org_id);
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <input
                                                                        disabled={!location.staion_name}
                                                                        style={{
                                                                            backgroundColor: !location.staion_name ? "#e9ecef" : undefined,
                                                                        }}
                                                                        type="text"
                                                                        className="form-control w-100"
                                                                        placeholder="Enter Handler Name"
                                                                        value={location.handler_name || ""}
                                                                        onChange={(e) => {
                                                                            updateLocationField(locationIndex, "handler_name", e.target.value);
                                                                            updateLocationField(locationIndex, "handler_id", "");
                                                                        }}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Label>
                                                            Loading / Unloading <span>*</span>
                                                        </Form.Label>
                                                        <div className="d-flex lodng_unldng_dv">
                                                            <Form.Check
                                                                type="radio"
                                                                label="Loading"
                                                                name={`trip_status_${locationIndex}`}
                                                                className="mt-2"
                                                                id={`loadingus_${locationIndex}`}
                                                                checked={location.trip_status === "L"}
                                                                onChange={() => updateLocationField(locationIndex, "trip_status", "L")}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                label="Unloading"
                                                                name={`trip_status_${locationIndex}`}
                                                                className="mt-2"
                                                                id={`unloading_${locationIndex}`}
                                                                checked={location.trip_status === "U"}
                                                                onChange={() => updateLocationField(locationIndex, "trip_status", "U")}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {/* CHILD SEQUENCES */}
                                                {/* <h2 className="mt-3">Loading Sequence</h2> */}

                                                {location.sequences.map((seq, seqIndex) => (
                                                    <div className={`trip_card_child`}

                                                        key={seq.id}              // ✅ FIXED KEY
                                                    // draggable={true}          // ✅ enable drag
                                                    // onDragStart={() => {
                                                    //     dragSeqRef.current = { locationIndex, seqIndex };
                                                    //     setDraggingSeq({ locationIndex, seqIndex });
                                                    // }}
                                                    // onDragEnter={() => {
                                                    //     dragOverSeqRef.current = { locationIndex, seqIndex };
                                                    // }}
                                                    // onDragOver={(e) => {
                                                    //     e.preventDefault();
                                                    // }}
                                                    // onDragEnd={() => {
                                                    //     const from = dragSeqRef.current;
                                                    //     const to = dragOverSeqRef.current;

                                                    //     if (
                                                    //         from.locationIndex === null ||
                                                    //         to.locationIndex === null
                                                    //     ) return;

                                                    //     // only allow reorder inside same location
                                                    //     if (from.locationIndex !== to.locationIndex) return;

                                                    //     reorderSequences(locationIndex, from.seqIndex, to.seqIndex);
                                                    //     setSelectedSeq({ locationIndex, seqIndex: to.seqIndex });
                                                    //     setDraggingSeq(null);

                                                    //     dragSeqRef.current = { locationIndex: null, seqIndex: null };
                                                    //     dragOverSeqRef.current = { locationIndex: null, seqIndex: null };
                                                    // }}
                                                    >
                                                        <Row className="align-items-center">
                                                            <Col md={5}>
                                                                <Row>
                                                                    <Col md={7}>
                                                                        <Form.Label>Truck Number <span>*</span></Form.Label>

                                                                        <div className="d-flex mb-2 align-items-center">
                                                                            <Select
                                                                                options={getOwnerCodes}
                                                                                placeholder="Code"
                                                                                className="autoslct w-100 p-0 me-2"
                                                                                value={getOwnerCodes.find(opt => opt.value === seq.flight_prefix) || null}
                                                                                onChange={(selected) =>
                                                                                    updateSequenceField(locationIndex, seqIndex, "flight_prefix", selected?.value || "")
                                                                                }
                                                                            />

                                                                            <Form.Control
                                                                                type="text"
                                                                                maxLength="8"
                                                                                value={seq.flight_no || ""}
                                                                                // onInput={(e) => {
                                                                                //     e.target.value = e.target.value.replace(/\D/g, "").slice(0, 8);
                                                                                // }}
                                                                                onChange={(e) =>
                                                                                    updateSequenceField(locationIndex, seqIndex, "flight_no", e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </Col>

                                                                    <Col md={5}>
                                                                        <Form.Label>Truck Date <span>*</span></Form.Label>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            value={seq.truck_date || ""}
                                                                            onChange={(e) =>
                                                                                updateSequenceField(locationIndex, seqIndex, "truck_date", e.target.value)
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            <Col md={4}>
                                                                <Form.Label>
                                                                    Intact / Loose <span>*</span>
                                                                </Form.Label>
                                                                <div className="d-flex intact_loose_dv">
                                                                    <Form.Check
                                                                        type="radio"
                                                                        label="Intact"
                                                                        name={`intact_loose_${locationIndex}_${seqIndex}`}
                                                                        id={`intact_${locationIndex}_${seqIndex}`}
                                                                        className=""
                                                                        checked={seq.intact_loose === "Intact"}
                                                                        onChange={() =>
                                                                            updateSequenceField(locationIndex, seqIndex, "intact_loose", "Intact")
                                                                        }
                                                                    />
                                                                    <Form.Check
                                                                        type="radio"
                                                                        label="Loose"
                                                                        name={`intact_loose_${locationIndex}_${seqIndex}`}
                                                                        id={`loose_${locationIndex}_${seqIndex}`}
                                                                        className=""
                                                                        checked={seq.intact_loose === "Loose"}
                                                                        onChange={() =>
                                                                            updateSequenceField(locationIndex, seqIndex, "intact_loose", "Loose")
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                            {location.trip_status === "L" &&
                                                                <Col md={3} className="Loading_Sequence_dv">
                                                                    <Form.Group>
                                                                        <Form.Label>
                                                                            Loading Sequence <span className="text-danger">*</span>
                                                                        </Form.Label>
                                                                        <Form.Select
                                                                            value={seq.loading_sequence}
                                                                            onChange={(e) => {
                                                                                const newIndex = Number(e.target.value) - 1;
                                                                                changeSequenceOrder(locationIndex, seqIndex, newIndex);
                                                                            }}
                                                                        >
                                                                            {location.sequences.map((_, i) => (
                                                                                <option key={i} value={i + 1}>
                                                                                    {i + 1}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    {/* <span className="loading_sequence_count">
                                                                        Loading Sequence <span className="ms-2">{seq.loading_sequence ?? (seqIndex + 1)}
                                                                            <Form.Control
                                                                                type="text"
                                                                                maxLength="8"
                                                                                value={seq.loading_sequence ?? (seqIndex + 1)}
                                                                                onChange={(e) =>
                                                                                    updateSequenceField(locationIndex, seqIndex, "loading_sequence", e.target.value)
                                                                                }
                                                                            />
                                                                        </span>
                                                                    </span> */}
                                                                </Col>
                                                            }
                                                            <Col md={12} className="text-end">
                                                                {location.sequences.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="add_btn close_btn" style={{ width: 'initial' }}
                                                                        onClick={() => removeSequence(locationIndex, seqIndex)}
                                                                    >
                                                                        <FontAwesomeIcon icon={faXmark} />
                                                                    </button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                ))}

                                                {/* Add Sequence Button */}
                                                <div className="pt-0">
                                                    <Row>
                                                        <Col md={12} className="text-left">
                                                            <button style={{ width: '200px' }}
                                                                type="button"
                                                                className="add_btn"
                                                                onClick={() => addSequence(locationIndex)}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} /> Add Truck Order
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                {/* Delete Location Button */}
                                                <div className="pt-0">
                                                    <Row>
                                                        <Col md={12} className="text-end">
                                                            {todFormData.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="add_btn dlt_btn"
                                                                    onClick={() => deleteLocation(locationIndex)}
                                                                >

                                                                    <img src={trash} alt='trash' />
                                                                </button>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="add_location text-center mt-3">
                                            <button type="button" onClick={addLocation}>Add location</button>
                                        </div>
                                    </div>
                                }
                                {activeStep === 3 &&
                                    <div>
                                        <Row>
                                            <Col sm="6" className='pe-0'>
                                                <div className="loading_dv">
                                                    <h2>Loading Station</h2>
                                                    <StationLoop type="loading" data={sbFormData.loading} setSbFormData={setSbFormData} />
                                                </div>
                                            </Col>
                                            <Col sm="6">
                                                <div className="unloading_dv">
                                                    <h2>Unloading Station</h2>
                                                    <StationLoop type="unloading" data={sbFormData.unloading} setSbFormData={setSbFormData} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </div>
                            <div className="stepper-buttons are_bottom">
                                <button className="btn-prev" disabled={activeStep === 1} style={{ visibility: activeStep === 1 ? "hidden" : "visible" }} onClick={goPrevious}>
                                    {activeStep > 1 && <>Previous</>}
                                </button>

                                <button className="btn-next" onClick={activeStep === 3 ? handleSubmit : goNext}>
                                    {activeStep === 3 ? "Finalize" : "Next"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal show={orderDetailsModal} onEntered={loadGrid} onHide={() => setOrderDetailsModal(false)} className='addfrom change_type truck_monitor_modal' centered size={'xl'} scrollable={true}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Add Truck Order</h3>
                    <p>Please select any order in this list</p>
                    <Row>
                        <Col md={6}>
                            {!isLoadingod && (
                                <div ref={gridRefs} className="staion_grid" />
                            )}
                        </Col>
                        <Col md={6}>
                            <div className="oder_details driver_truck_details selected_order_list">
                                <h3>Selected Orders</h3>
                                {gridSelectData.map((order, index) => (
                                    <div className="order_details_list" key={order.id ?? index}>
                                        <div className="oder_no">
                                            <h6>Order No.</h6>
                                            <p>{order.order_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck No.</h6>
                                            <p>{order.truck_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck Date</h6>
                                            <p>{order.truck_date
                                                ? new Date(order.truck_date).toISOString().split('T')[0]
                                                : ''
                                            }</p>
                                        </div>

                                        <div className="dlt_icon"
                                            onClick={() => uncheckGridRowById(order.id)}
                                        >
                                            <img src={bin} alt="bin" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-25 are_bottom">
                        <Button variant="primary" onClick={() => handleAddorder()} className='me-3'> Add Order</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TripEditModal;